import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {ModelsDataProvider} from '../data/ModelsDataProvider';
import {SimulationSessionProvider} from '../data/SimulationSessionProvider';
import {MatDialog} from '@angular/material/dialog';
import {NewSessionDialogComponent} from '../new-session-dialog/new-session-dialog.component';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {

  siteLanguage = 'Français';
  siteLocale!: string;
  languageList = [
    { code: 'fr', label: 'Français' },
    { code: 'nl', label: 'Nederlands' }
  ];

  constructor(private translate: TranslateService, private modelsDataProvider: ModelsDataProvider, private simulationSessionProvider: SimulationSessionProvider, public dialog: MatDialog, private router: Router) {
    this.siteLocale = window.location.pathname.split('/')[1];
    this.setLanguage(this.siteLocale);
    localStorage.setItem('aristometrix_lang', this.siteLocale);
  }

  changeLanguage(lang: string) {
    this.setLanguage(lang);
  }

  setLanguage(lang: string) {
    const localCode = this.languageList.find(f => f.code === lang);
    if (localCode) {
      this.translate.setDefaultLang(localCode.code);
      this.siteLanguage = localCode.label;
      localStorage.setItem('aristometrix_lang', localCode.code);
    }
    else {
      this.translate.setDefaultLang('fr');
      this.siteLanguage = 'Français';
      localStorage.setItem('aristometrix_lang', 'fr');
    }
    this.modelsDataProvider.loadModels();
  }

  ngOnInit(): void {
  }

  public goHome() {
    const dialogRef = this.dialog.open(NewSessionDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result && result === true){
        this.simulationSessionProvider.resetSimulationSession();
        this.router.navigate(['/home']);
      }
    });
  }


}

